import { IMGS_PATH } from 'constants/image';
import Image from 'components/ui/Image';
import { useTranslation } from 'hooks/useTranslation';
import styles from './PaymentFormStep3.module.scss';

const PaymentFormStep3 = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className={styles.paymentFormStep3Wrapper}>
      <p className={styles.paymentFormStep3Headline}>
        {t('referAFriend.rewardForm.thankYou.headline')}
      </p>
      <Image
        src={`${IMGS_PATH.PUBLIC}/tada.png`}
        alt=""
        height={160}
        width={160}
      />
      <p className={styles.paymentFormStep3Description}>
        {t('referAFriend.rewardForm.thankYou.description')}
      </p>
    </div>
  );
};

export default PaymentFormStep3;
